<template>
  <div class="privacy">
    <div class="dialog-content" v-html="privacy"></div>
  </div>
</template>

<script>
import { getVariableInfo } from '@/api/variable';
export default {
  name: 'Privacy',
  data () {
    return {
      privacy: '123456789734564',
    }
  },
  mounted() {
    this.getPrivacy();
  },
  methods: {
    getPrivacy() {
      getVariableInfo({ label: 'privacy' }).then((res) => {
        const { result, } = res;
        var doc = new DOMParser().parseFromString(result.content, 'text/html');
        this.privacy = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
      });
    }
  }
}
</script>

<style lang="less" scoped>
.privacy {
  display: block;
  .dialog-content{
    padding: 50px 25px;
  }
}
</style>
